import setLoading from 'components/loading'
import { groupItems } from '../../apps/admin/applicationSettings/modals/newInspectionTemplate/containers/contentContainer/utils';

import { formatPrice } from 'utils';

export default {
  'InspectionTemplates.TitleWrapper.Buttons.Button': ({ }, outlet) => {
    outlet({
      action: 'open_modal',
      type: 'new_inspection_template',
      data: {
        categories: [{ items: [{ name: '', options: [] }] }],
        property_ids: window?.properties ? [...window?.properties?.map((p) => p.id)] : [],
        group_ids: [],
        auto_add_new_properties: true,
        cancelAutogenerateInspection: false,
        active: true,
        autogenerateInspection: 1,
        autogenerateInspectionDays: 1,
        autogenerateInspectionSign: 1,
        autogenerateInspectionTargetDate: 'move_in_date',
        autoAddDueDate: false,
        autoAddDueDateDays: 14

      },
    })
  },
  'InspectionTemplates.Templates.Badge': async ({ action, badge }, outlet) => {
    if (action === 'primary') {
      let changedItems = badge.items ? [...badge.items] : [];
      changedItems = changedItems.map((i) => ({
        ...i,
        options: i.options.map((o) => ({
          ...o,
          cost: o.cost_in_cents !== null ? formatPrice(`${o.cost_in_cents / 100}`, true) : null
        }))
      }));

      outlet({
        type: "editTemplate",
        data: {
          ...badge,
          active: badge.active,
          resident_to_charge: badge.charge_to,
          charge_resident: !!badge.charge_to,
          hasCharges: badge.has_charges,
          categories: groupItems({ items: changedItems }),
          cancelAutogenerateInspection: badge.cancel_auto_inspection,
          autogenerateInspection: badge.automation_rules.length > 0,
          autogenerateInspectionDays: Math.abs(badge.automation_rules[0]?.diff_in_days || 1),
          autogenerateInspectionSign: badge.automation_rules[0]?.diff_in_days < 0 ? -1 : 1,
          autogenerateInspectionTargetDate: badge.automation_rules[0]?.target_date || 'move_in_date',
          autoAddDueDate: badge.automation_rules.length > 0 && badge.automation_rules[0]?.due_date_diff_in_days != null,
          autoAddDueDateDays: badge.automation_rules[0]?.due_date_diff_in_days || 14
        },
      })
    } else {
      outlet({
        type: "DeactivateTemplate",
        data: {
          ...badge,
          active: false
        },
      })
    }
  },
  'InspectionTemplates.DeactivatedInspectionTemplates.Badge': async ({ action, badge }, outlet) => {
    if (action === 'primary') {
      let changedItems = badge.items ? [...badge.items] : [];
      changedItems = changedItems.map(i => ({ ...i, options: i.options.map(o => ({ ...o, cost: o.cost_in_cents !== null ? formatPrice(`${o.cost_in_cents / 100}`, true) : null })) }))

      outlet({
        type: "editTemplate",
        data: {
          ...badge,
          resident_to_charge: badge.charge_to,
          active: badge.active,
          charge_resident: !!badge.charge_to,
          hasCharges: badge.has_charges,
          categories: groupItems({ items: changedItems }),
          cancelAutogenerateInspection: badge.cancel_auto_inspection,
          autogenerateInspection: badge.automation_rules.length > 0,
          autogenerateInspectionDays: Math.abs(badge.automation_rules[0]?.diff_in_days || 1),
          autogenerateInspectionSign: badge.automation_rules[0]?.diff_in_days < 0 ? -1 : 1,
          autogenerateInspectionTargetDate: badge.automation_rules[0]?.target_date || 'move_in_date',
          autoAddDueDate: badge.automation_rules.length > 0 && badge.automation_rules[0]?.due_date_diff_in_days != null,
          autoAddDueDateDays: badge.automation_rules[0]?.due_date_diff_in_days || 14
        },
      })
    } else {

      outlet({
        type: "ActivateTemplate",
        data: {
          ...badge,
          active: true
        },
      })
    }
  },
  'InspectionTemplates.TitleWrapper.PropertyContainer': ({ selectedPropertyIds, selectedGroupIds }, _, internalStateSetter) => {
    internalStateSetter({ selectedPropertyIds, selectedGroupIds })
  },
  'InspectionTemplates.Tabs.Active': ({ }, _, internalStateSetter) => {
    internalStateSetter({ selectedTab: 'active_templates' })
  },
  'InspectionTemplates.Tabs.Deactivated': ({ }, _, internalStateSetter) => {
    internalStateSetter({ selectedTab: 'deactivated_templates' })
  },
  'InspectionTemplates.Tabs.Tags': ({ }, _, internalStateSetter) => {
    internalStateSetter({ selectedTab: 'tags' })
  },
  'InspectionTemplates.TagsWrapper.Button': ({ }, _, internalStateSetter) => {
    internalStateSetter({ visibleTagInput: true })
  },
  'InspectionTemplates.TagsWrapper.InputWrapper.TagsInput': async ({ value, tagColors, action, inspectionTags, properties }, outlet) => {

    if (action === 'focused') return;
    outlet({
      type: "createTag",
      data: {
        name: value,
        color: tagColors[(inspectionTags?.filter((t) => t.is_active)?.length ?? 0) % 6],
        priority_id: null,
        property_ids: window?.properties ? [...window?.properties?.map((p) => p.id)] : [],
        group_ids: [],
        auto_add_new_properties: true,
        is_active: true
      },
    })

  },
  'InspectionTemplates.TagsWrapper.InputWrapper.Cancel': ({ }, _, internalStateSetter) => {
    internalStateSetter({ visibleTagInput: false })
  },
  'InspectionTemplates.TagsWrapper.AddNew': ({ }, _, internalStateSetter) => {
    internalStateSetter({ visibleTagInput: true })
  },
  'InspectionTemplates.TagsWrapper.Tag': async ({ action, tag }, outlet) => {
    const type = `tag_${action}`;
    const data = (() => {
      switch (action) {
        case 'copy':
          return { ...tag, id: null, copied_from_id: tag.id };
        case 'delete':
          return { ...tag, is_active: false };
        default:
          return tag;
      }
    })();

    outlet({
      type: type,
      data: data,
    })
  }
}
